// extracted by mini-css-extract-plugin
export default {"pageLoader":"pageLoader__mAp5I","spinner":"spinner__y0hsW","spin":"spin__rBYx5","shimmerCard":"shimmerCard__U7FRs","shimmerLine":"shimmerLine__voebH","shimmer":"shimmer__t1mV7"};